import { forwardRef } from '@chakra-ui/react';

import { ChevronRightIcon, IconProps } from '@frontend/components';

import { useThinkingContext } from '../ThinkingContext';
import { useThinkingStyles } from '../useThinkingStyles';

export type ThinkingExpandIndicatorProps = IconProps;

export const ThinkingExpandIndicator: React.FC<ThinkingExpandIndicatorProps> =
  forwardRef<ThinkingExpandIndicatorProps, 'div'>(({ ...props }, ref) => {
    const { expandIndicator } = useThinkingStyles();
    const { isExpanded, isToggleExpansionDisabled } = useThinkingContext();

    return (
      <ChevronRightIcon
        sx={expandIndicator}
        className="thinking-expand-indicator"
        // Apply attributes in relevant states to connect to styles.
        data-expanded={isExpanded}
        data-can-expand={!isToggleExpansionDisabled}
        {...props}
        ref={ref}
      />
    );
  });
